import { AddressesRepository } from '@lib/api/repository/addresses/addresses.repository';
import { PostalCodeRepository } from '@lib/api/repository/postal-code/postal-code.repository';
import { AddressInput } from '@lib/types';

export default class AddressesService {
  constructor(
    private repository: AddressesRepository,
    private postalCodes: PostalCodeRepository,
  ) {}

  list(signal?: AbortSignal) {
    return this.repository.list(signal);
  }

  create(input: AddressInput) {
    return this.repository.create(input);
  }

  update(id: string, input: AddressInput) {
    return this.repository.update(id, input);
  }

  remove(id: string) {
    return this.repository.remove(id);
  }

  findPostalCode(postalCode: string) {
    return this.postalCodes.find(postalCode);
  }

  listStates(signal?: AbortSignal) {
    return this.repository.listStates(signal);
  }

  listCities(stateId: string, signal?: AbortSignal) {
    return this.repository.listCities(stateId, signal);
  }
}
